import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import PageBreadcrumb from "../common/PageBreadCrumb";
import PageMeta from "../common/PageMeta";
import ComponentCard from "../common/ComponentCard";
import Label from "../form/Label";
import Input from "../form/input/InputField";
import Radio from "../form/input/Radio";
import TextArea from "../form/input/TextArea";
import Select from "../form/Select";
import Button from "../ui/button/Button";
import Alert from "../../components/ui/alert/Alert";
import { CheckLineIcon, CloseLineIcon } from "../../icons";
import { createUserSubscription, resetCreateUserSubscription, getSubscriptionById, emptyReduxSubscription } from "../../actions/subscriptionAction";
import { checkAuth, getAccountProfile, emptyReduxUser } from "../../actions/userAction";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";


export default function PlanRequest() {

  dayjs.extend(relativeTime);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const params = useParams();

  const getAccountProfileRes = useSelector(state => state.userReducer.getAccountProfile);
  
  const getAccountProfileFailed = useSelector(state => state.userReducer.getAccountProfileFailed);

  const createUserSubscriptionRes = useSelector(state => state.subscriptionReducer.createUserSubscription);

  const createUserSubscriptionFailed = useSelector(state => state.subscriptionReducer.createUserSubscriptionFailed);

  const getSubscriptionPlanRes = useSelector(state => state.subscriptionReducer.getSubscriptionPlan);

  const getSubscriptionPlanFailed = useSelector(state => state.subscriptionReducer.getSubscriptionPlanFailed);


  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

   const [showLoginLoader, setShowLoginLoader] = useState(false);
  
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const [profileData, setProfileData] = useState({});

  const [subscriptionData, setSubscriptionData] = useState({});

  const [title, setTitle] = useState("");
  const [errorTitle, setErrorTitle] = useState(false);

  const [description, setDescription] = useState("");
  const [errorDescription, setErrorDescription] = useState(false);

  const [schedule, setSchedule] = useState("");
  const [errorSchedule, setErrorSchedule] = useState(false);

  const [tenure, setTenure] = useState("");
  const [errorTenure, setErrorTenure] = useState(false);

  const [amount, setAmount] = useState("");
  const [errorAmount, setErrorAmount] = useState(false);

  const [scheduleType, setScheduleType] = useState("fixed");
  const [errorScheduleType, setErrorScheduleType] = useState(false);




  const [scheduleOptions, setScheduleOptions] = useState([
    { value: "weekly", label: "weekly" },
    { value: "monthly", label: "monthly" },
    { value: "yearly", label: "yearly" },
  ]);

  const fixed_scheduleOptions = [
    { value: "weekly", label: "weekly" },
    { value: "monthly", label: "monthly" },
    { value: "yearly", label: "yearly" },
  ];

  useEffect(() => {
    dispatch(checkAuth());
    dispatch(getAccountProfile());
    dispatch(getSubscriptionById(params.id));
    
  }, []);
 

  useEffect(() => {

    if(checkAuthFailed.statusCode == 401){
      //toast.error(checkAuthFailed.message, {autoClose:2000,onClose: () => {
            dispatch(emptyReduxUser());
            dispatch(emptyReduxSubscription());
            logout();
            navigate("/signin");
      //}});
    }

  }, [checkAuthFailed]);

  useEffect(() => {

    if(typeof getAccountProfileRes != "undefined" && getAccountProfileRes.statusCode == 200){
      console.log("getAccountProfileRes", getAccountProfileRes);

      let data = getAccountProfileRes.data;

      setProfileData(data);

      /*setFirstName(data.firstName);
      setLastName(data.lastName);
      //setEmail("");
      setPhone(data.phone);
      setPhone2(data.phone2);
      setAddress(data.address1);
      setAddress2(data.address2)
      setCity(data.city);
      setState(data.state);
      setCountry(data.country);
      setPinCode(data.pinCode);*/
    }

  }, [getAccountProfileRes]);

  useEffect(() => {

    if(typeof getSubscriptionPlanRes != "undefined" && getSubscriptionPlanRes.statusCode == 200){

      let data = getSubscriptionPlanRes.data;

      console.log("data sub:- ", data);

      setSubscriptionData(data);
    }

  }, [getSubscriptionPlanRes]);
  

  useEffect(() => {
    
    if(typeof createUserSubscriptionRes != "undefined" && createUserSubscriptionRes.statusCode == 200){

      console.log("createUserSubscriptionRes", createUserSubscriptionRes);

      dispatch(resetCreateUserSubscription());

      setShowSuccessAlert(true);

      setShowLoginLoader(false);
      
      setTimeout(() => {
        setShowSuccessAlert(false);
        //navigate("/subscription/self");
      },3000);
    }

  }, [createUserSubscriptionRes]);


  useEffect(() => {
    // console.log(getBotOperatorFailed);
    if(createUserSubscriptionFailed.statusCode == 401){
        //dispatch(emptyRedux());
        setShowLoginLoader(false);
        logout();
        navigate("/signin");
    }
  }, [createUserSubscriptionFailed]);


  const addDate = (currentDate, count, schedule) => {
  
    let newDate = new Date(currentDate);

    if(schedule === "yearly"){
      newDate.setFullYear(newDate.getFullYear() + count);
    }

    if(schedule === "monthly"){
      newDate.setMonth(newDate.getMonth() + count);
    }

    if(schedule === "weekly"){
      newDate.setDate(newDate.getDate() + count * 7);
    }

    return newDate;
  }

  const handleSubmit = (e) => {

    e.preventDefault();

    console.log("Enterted tmpEndData");

    let tmpEndData = addDate(new Date(), subscriptionData.tenure, subscriptionData.schedule);

    setShowLoginLoader(true);
    
    let data = {
      "userId" : localStorage.id,
      "subscriptionPlanId" : params.id,
      "startDate" : dayjs(new Date()).format('YYYY-MM-DD'),
      "endDate" : dayjs(tmpEndData).format('YYYY-MM-DD'),
    };

    dispatch(createUserSubscription(data));
  } 

  const goToBack = (e) => {
      e.preventDefault();
      navigate("/subscription/select");
  }
  
  return (
    <div>
      <PageMeta
        title="Add subscrioption plan | Chit Fund Management System"
        description="Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Subscription plan" />
      <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] lg:p-6">
        
        <div className="space-y-6">
          {(
            showSuccessAlert 

            ? 

            <Alert
              variant="success"
              title="Done!"
              message="You have subscribed new plan."
              showLink={false}
            />

            : 
            
            null
          )}


          <div className="p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
              <div>
                <h4 className="text-lg font-semibold text-gray-800 dark:text-white/90 lg:mb-6">
                  Personal Information
                </h4>
      
                <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-7 2xl:gap-x-32">
                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      First Name
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                      {profileData.firstName ? profileData.firstName : null}
                    </p>
                  </div>
      
                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      Last Name
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                    {profileData.lastName ? profileData.lastName : null}
                    </p>
                  </div>
      
                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      Email address
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                      {localStorage.email ? localStorage.email : null}
                    </p>
                  </div>
      
                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      Phone
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                      {profileData.phone ? profileData.phone : null}
                    </p>
                  </div>

                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      Address 1
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                    {profileData.address1 ? profileData.address1 : null}
                    </p>
                  </div>

                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      Address 2
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                    {profileData.address2 ? profileData.address2 : null}
                    </p>
                  </div>

                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      City/State
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                      {profileData.city ? profileData.city : null}, {profileData.state ? profileData.state : null}
                    </p>
                  </div>
      
                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      Country
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                    {profileData.country ? profileData.country : null}
                    </p>
                  </div>
    
                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      Postal Code
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                    {profileData.pinCode ? profileData.pinCode : null}
                    </p>
                  </div>


                </div>
              </div>
      
            </div>
    
          </div>
          
          

          <div className="p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
              <div>
                <h4 className="text-lg font-semibold text-gray-800 dark:text-white/90 lg:mb-6">
                  Plan detail
                </h4>
    
                <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-7 2xl:gap-x-32">
                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      Name
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                      {subscriptionData.name}
                    </p>
                  </div>
    
                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      Tenure
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                    {(
                      subscriptionData.scheduleType === "fixed"
                      ?
                      subscriptionData.tenure + ' ' + (subscriptionData.schedule == "monthly" ? "month(s)" : (subscriptionData.schedule == "weekly" ? "week(s)" : "year(s)"))
                      :
                      "No limit"
                    )}
                    </p>
                  </div>
    
                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      Amount
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                    {(
                      subscriptionData.scheduleType === "fixed"
                      ?
                      <>&#8377;{subscriptionData.amount}</>
                      :
                      <>&#8377;500 - &#8377;50,000</>
                    )}
                    
                    </p>
                  </div>
    
                  <div>
                    <p className="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      Description
                    </p>
                    <p className="text-sm font-medium text-gray-800 dark:text-white/90">
                    {subscriptionData.description}
                    </p>
                  </div>
                </div>
              </div>
    
            </div>
          </div>
          <div className="space-x-6 text-right">
              <Button size="sm" variant="primary" startIcon={( showLoginLoader ? null : <CheckLineIcon />)} onClick={(e) => handleSubmit(e)}>
              {(
                  showLoginLoader 

                  ? 

                  <span class="animate-spin" ><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.5" cx="10" cy="10" r="8.75" stroke="white" stroke-width="2.5"></circle><mask id="path-2-inside-1_3755_26472" fill="white"><path d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z"></path></mask><path d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z" stroke="white" stroke-width="4" mask="url(#path-2-inside-1_3755_26472)"></path></svg></span>

                  : 
                  
                  null
                )}
                Create
              </Button>
              <Button size="sm" onClick={goToBack} variant="outline" startIcon={<CloseLineIcon />}>
                Cancel
              </Button>
          </div>
        </div>
      </div>

    </div>
  );
}
